import { 
    legacy_createStore as createStore,
    combineReducers, 
    applyMiddleware,
    compose
} from 'redux'
import authReducer from './auth/reducer';
import { thunk } from 'redux-thunk';
import appointmentReducer from './appointment/reducer';
import registrationReducer from './registration/reducer';
import patientReducer from './patient/reducer';

const composerEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// const initialState = {};

// const middleware = [thunk];

const rootReducers = combineReducers({
    auth: authReducer,
    appointment: appointmentReducer,
    registration: registrationReducer,
    patient: patientReducer
});

const store = createStore(
    rootReducers,
    composerEnhancer(applyMiddleware(thunk))
);

export default store;